// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!./BackgroundTrainer.js";

export function getWorker() {
  return new Worker();
}
